import { Button } from "./ui/button";
import { ArrowLeft } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import { useTenantNavigation } from "../hooks/useTenantNavigation";

/**
 * "Back to Admin Panel" button — renders only for users with admin role.
 * Used inside page headers so admins can return to the Admin Panel from
 * any nested screen (Equipment Hours, Material Movements, Delays, etc.).
 */
export default function AdminBackButton({ className = "" }) {
  const { user } = useAuth();
  const { navigate } = useTenantNavigation();
  if (user?.role !== "admin") return null;
  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={() => navigate("/admin")}
      className={`text-xs gap-1.5 ${className}`}
      data-testid="back-to-admin-btn"
      title="Back to Admin Panel"
    >
      <ArrowLeft className="h-3.5 w-3.5" strokeWidth={1.5} />
      Admin
    </Button>
  );
}
